import { render, staticRenderFns } from "./InviteAdminModal.vue?vue&type=template&id=b089437a&scoped=true&"
import script from "./InviteAdminModal.vue?vue&type=script&lang=js&"
export * from "./InviteAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteAdminModal.vue?vue&type=style&index=0&id=b089437a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089437a",
  null
  
)

export default component.exports